import {
  Component,
  Input,
  Output,
  ViewEncapsulation,
  EventEmitter,
  TemplateRef,
  inject,
  OnInit,
  viewChild,
  ViewContainerRef,
  OnDestroy,
  input,
  effect
} from '@angular/core';

import { TemplatePortal } from '@angular/cdk/portal';
import { AppPortalOutlet, PortalService } from '@app/core/services/portal.service';

@Component({
  selector: 'topo-modal',
  imports: [],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit, OnDestroy {
  isActive = input.required<boolean>();
  @Input() isCard = false;
  @Input() width = 640;
  @Input() rawWidth = null;
  @Input() rawHeight = null;
  @Input() backgroundCanClose = false;
  @Input() backgroundColor = 'var(--background-color-1)';
  @Input() headerIsFullWidth = false;
  @Input() noHeaderBorder = false;
  @Input() removeHeaderBottomPadding = false;
  @Input() hideFooter = false;
  @Input() noBodyPadding = false;
  @Input() showLoadingOverlay = false;
  @Input() loadingMessage: string;

  @Output() close = new EventEmitter();
  @Output() contentScrolled = new EventEmitter();

  private modalTemplateRef = viewChild('modalTemplate', { read: TemplateRef });
  private vcr = inject(ViewContainerRef);
  private portal: TemplatePortal;
  private portalOutlet: AppPortalOutlet;
  private portalService = inject(PortalService);

  ngOnInit(): void {
    this.portal = new TemplatePortal(this.modalTemplateRef(), this.vcr);
  }

  ngOnDestroy(): void {
    if (this.portal?.isAttached) {
      this.portal?.detach();
      this.portalOutlet?.dispose();
    }
  }

  handleIsActive$ = effect(() => {
    const isActive = this.isActive();

    if (isActive) {
      if (!this.portal?.isAttached) {
        const elementId = this.vcr.element.nativeElement.id;
        this.portalOutlet = this.portalService.createPortalOutlet(elementId.length ? elementId : undefined);
        this.portal?.attach(this.portalOutlet.instance);
      }
    } else {
      if (this.portal.isAttached) {
        this.portal?.detach();
        this.portalOutlet.dispose();
      }
    }
  });

  closeClick(): void {
    this.close.emit();
  }

  bodyScroll(): void {
    this.contentScrolled.emit();
  }
}
